// @flow

export default class {
  static sleep(ms: number): Promise<void> {
    // FIXME 稀に 1ms ずれてテストが失敗するため、 1 足している
    return new Promise(resolve => setTimeout(resolve, ms + 1));
  }
}



// WEBPACK FOOTER //
// ./src/lib/timer/timer.js